// BaselineAcceptBanner.js — PRD-63 WP1
//
// Render conditions are decided by the parent (DriftAlarms.js). This component
// is a presentational shell with two CTAs: a primary "Accept All as Initial
// Baseline" button and a secondary "Review one at a time" link that
// permanently dismisses the banner for this asset.

import React from 'react';

function BaselineAcceptBanner({ asset, openAlarmCount, onAcceptAll, onDismiss, dismissing }) {
    if (!asset || !openAlarmCount) return null;

    const assetName = asset.assetName || asset.value || asset.target || asset.assetId;

    return (
        <div className="baseline-banner" role="region" aria-label="Initial baseline prompt">
            <div className="baseline-banner__icon" aria-hidden="true">🌱</div>
            <div className="baseline-banner__body">
                <div className="baseline-banner__title">
                    This is your first scan of <strong>{assetName}</strong>
                </div>
                <div className="baseline-banner__text">
                    We detected <strong>{openAlarmCount} open alarm{openAlarmCount !== 1 ? 's' : ''}</strong>.
                    Accept them as your initial baseline to start tracking only NEW changes going
                    forward. Want to review them individually first? You can Ignore false positives
                    one at a time.
                </div>
            </div>
            <div className="baseline-banner__actions">
                <button
                    type="button"
                    className="baseline-banner__primary"
                    onClick={onAcceptAll}
                    disabled={dismissing}
                >
                    Accept All as Initial Baseline
                </button>
                <button
                    type="button"
                    className="baseline-banner__secondary"
                    onClick={onDismiss}
                    disabled={dismissing}
                >
                    Review one at a time →
                </button>
            </div>
        </div>
    );
}

export default BaselineAcceptBanner;
